import * as fmt from '../../lib/format';
import { TechData, TechKpi } from './types';

// The words on the Tech Home, written from the numbers by lib/format (never generated).

/** What a figure is compared with: the same first days of the month before while the month is open, the whole month once it is over. */
export function comparedLabel(t: Pick<TechData, 'period' | 'days_compared' | 'period_over'>): string {
  const [y, m] = t.period.split('-').map(Number);
  const prev = fmt.monthOnly(m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, '0')}`);
  return t.period_over ? `vs ${prev}` : `vs the first ${t.days_compared} ${t.days_compared === 1 ? 'day' : 'days'} of ${prev}`;
}

/** "up 12% on the first 17 days of September": how a figure moved against the same days of the month before. */
export function movedSentence(k: TechKpi, t: Pick<TechData, 'period' | 'days_compared' | 'period_over'>): string {
  if (k.change_pct === null) return 'no comparison yet';
  const against = comparedLabel(t).replace(/^vs /, '');
  if (k.change_pct === 0) return `the same as ${against}`;
  return `${k.change_pct > 0 ? 'up' : 'down'} ${fmt.percent(Math.abs(k.change_pct))} on ${against}`;
}

/** One line over the three numbers: "148 shipped so far this month, 116 in progress, 113 waiting." */
export function monthSentence(t: TechData): string {
  const so = t.period_over ? '' : ' so far';
  return `${fmt.count(t.numbers.shipped.value)} shipped${so} this month, ${fmt.count(t.numbers.in_progress)} in progress, ${fmt.count(t.numbers.waiting)} waiting.`;
}

export function cameInSentence(t: TechData): string {
  const n = t.numbers.came_in;
  return `${fmt.counted(n.value, 'ask')} came in through intake, ${movedSentence(n, t)}.`;
}

/** What the function rows add up to: the Worklogs grid's hours, and every ticket in a row. */
export function functionsSentence(t: TechData): string {
  return `${fmt.hours(t.totals.hours)} logged by ${fmt.counted(t.totals.people, 'person', 'people')} this month, ${fmt.count(t.totals.shipped)} tickets shipped and ${fmt.count(t.totals.in_progress)} in progress.`;
}
